/** @typedef {{ id: string, label: string, group: string, path?: string, method?: string, allowed_roles: string[] }} AccessMatrixRow */
/** @typedef {{ id: string, org_roles: string[], emails: string[], screens?: AccessMatrixRow[], endpoints?: AccessMatrixRow[], updated_at?: string|null, updated_by?: string|null, source?: string }} ElevatedAccessConfig */

import api from './api';

function detailMessage(error, fallback) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

export const elevatedAccessApi = {
  async get() {
    try {
      const { data } = await api.get('/elevated-access-config');
      return data;
    } catch (e) {
      throw new Error(detailMessage(e, 'Failed to load authorisations'));
    }
  },

  async getMyAccess() {
    try {
      const { data } = await api.get('/elevated-access-config/me');
      return data;
    } catch (e) {
      throw new Error(detailMessage(e, 'Failed to load your access'));
    }
  },

  async save(payload) {
    try {
      const { data } = await api.put('/elevated-access-config', payload);
      return data;
    } catch (e) {
      throw new Error(detailMessage(e, 'Failed to save authorisations'));
    }
  },
};
